import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './styles/global.css';

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((registration) => {
      console.log('[SW] Registered:', registration.scope);

      // Check for updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        newWorker?.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // New SW available -- could show update prompt here in v2
            console.log('[SW] Update available');
          }
        });
      });
    }).catch((err) => {
      console.warn('[SW] Registration failed:', err);
    });
  });
}

// Track install prompt for deferred prompt
let deferredInstallPrompt = null;

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredInstallPrompt = e;

  // Show install banner after 2nd visit
  const visitCount = parseInt(localStorage.getItem('aigo_visit_count') || '0', 10);
  if (visitCount >= 2 && !localStorage.getItem('aigo_install_dismissed')) {
    window.dispatchEvent(new CustomEvent('aigo:showInstallBanner', { detail: { prompt: e } }));
  }
});

// Track visit count
const count = parseInt(localStorage.getItem('aigo_visit_count') || '0', 10);
localStorage.setItem('aigo_visit_count', String(count + 1));

// Expose install prompt globally for Settings page
window.__aigoInstallPrompt = () => deferredInstallPrompt;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
